(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-no-nav-landing"] && !Shopify.designMode) return;
  try {
    
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('[data-codex-landing] .codex-section, [data-codex-landing] .codex-final-cta');

  const mobileCta = document.querySelector('[data-codex-landing] .codex-mobile-cta');
  const heroSection = document.querySelector('[data-codex-landing] .codex-hero');
  const bookingSection = document.querySelector('[data-codex-landing] .codex-booking');
  const finalCtaSection = document.querySelector('[data-codex-landing] .codex-final-cta');
  const updateMobileCta = () => {
    if (!mobileCta || !heroSection || !bookingSection || !finalCtaSection) return;
    const heroRect = heroSection.getBoundingClientRect();
    const bookingRect = bookingSection.getBoundingClientRect();
    const finalRect = finalCtaSection.getBoundingClientRect();
    const bookingIsVisible = bookingRect.top < window.innerHeight * 0.82 && bookingRect.bottom > 80;
    const shouldShow = heroRect.bottom < 80 && !bookingIsVisible && finalRect.top > window.innerHeight * 0.72;
    mobileCta.classList.toggle('is-active', shouldShow);
    mobileCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };
  updateMobileCta();
  window.addEventListener('scroll', updateMobileCta, { passive: true });

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -36px' });

    revealItems.forEach((item) => {
      item.classList.add('codex-reveal');
      revealObserver.observe(item);
    });
  }

  document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-review-track]');
    const getDistance = () => {
      const card = track.querySelector('figure');
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
    };

    carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -getDistance(), behavior: 'smooth' });
    });

    carousel.querySelector('[data-review-next]')?.addEventListener('click', () => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + getDistance(), behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-codex-landing] [data-booking-cta]').forEach((link) => {
    link.addEventListener('click', () => {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', 'WarehouseShowingIntent');
    });
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com') return;
    if (event.data?.event !== 'calendly.event_scheduled') return;
    if (typeof window.fbq === 'function') window.fbq('track', 'Schedule');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
